import { NetworkTreeAction } from '../../networkAppContainer/helpers/types';
import { BaseActionHandlers } from './actionHandlers/base.action.handlers';
import { RenameActionHandlers } from './actionHandlers/rename.action.handlers';
import { CreateNetworkFolderActionHandlers } from './actionHandlers/create.network.folder.action.handlers';
import { CreateCompanyFolderActionHandlers } from './actionHandlers/create.company.folder.action.handlers';

export class TreeNodeActionHandlersFactory {
  public static create(actionType?: NetworkTreeAction): BaseActionHandlers {
    switch (actionType) {
      case NetworkTreeAction.RENAME:
        return new RenameActionHandlers();
      case NetworkTreeAction.CREATE_COMPANY_FOLDER:
        return new CreateCompanyFolderActionHandlers();
      case NetworkTreeAction.CREATE_NETWORK_FOLDER:
        return new CreateNetworkFolderActionHandlers();
      default:
        throw new Error(`Action handlers not implemented for action type: ${actionType}`);
    }
  }
}
